import type { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import type { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

import { DSB_PROGRAM_CODE } from '../config/constants'

export { DSB_PROGRAM_CODE }

const QUALIFYING_AGREEMENT_SUFFIXES = ['_VAR', '_VDM']

interface IFilterDsbProgramCodeByPartnerFlagsParams {
  partnerFlags: IPartnerFlag[]
  profilingCodes: IProfilingCode[]
  type: ProfilingCodeType.Accreditation | ProfilingCodeType.Program
}

export const hasQualifyingDsbAgreementFlag = (partnerFlags: IPartnerFlag[] = []) => {
  return partnerFlags.some((partnerFlag) => {
    if (partnerFlag?.codeType !== ProfilingCodeType.Agreement) {
      return false
    }

    const code = partnerFlag.code

    if (typeof code !== 'string') {
      return false
    }

    const normalizedCode = code.toUpperCase()

    return QUALIFYING_AGREEMENT_SUFFIXES.some((suffix) => normalizedCode.endsWith(suffix))
  })
}

export const filterDsbProgramCodeByPartnerFlags = ({
  partnerFlags,
  profilingCodes,
  type,
}: IFilterDsbProgramCodeByPartnerFlagsParams) => {
  if (type !== ProfilingCodeType.Program || hasQualifyingDsbAgreementFlag(partnerFlags)) {
    return profilingCodes
  }

  return profilingCodes.filter(({ code }) => code !== DSB_PROGRAM_CODE)
}
